import { createStore } from 'redux'
import { loadDoorSettingsState } from './localStorage-service';
const aaecState = require('../../../json/state/aaec-state.json');
// import { stateReducer } from './reducer'

function stateReducer(state = aaecState, action) {

	var state = state;
	// If localStorage is set take that state and use it further down in the actions
	if ( loadDoorSettingsState() !== undefined) {
		state = loadDoorSettingsState();
	}
	
	switch (action.type) {
		case 'CHANGE_PROJECT_NAME':
			// Simplest way of creating new object.
			var newState = JSON.parse(JSON.stringify(state));
			newState.projectName = action.name;
			return newState;

			break;

		case 'CHANGE_HEIGHT':
			var newState = JSON.parse(JSON.stringify(state));
			newState.door.properties.height = action.height;
			return newState;

			break;

		case 'CHANGE_WIDTH': 
			var newState = JSON.parse(JSON.stringify(state));
			newState.door.properties.width = action.width;
			return newState;

			break;

		case 'CHANGE_NUMBER_OF_WINDOW_PANEL': 
		    var newState = JSON.parse(JSON.stringify(state));
		    newState.door.properties.numberOfWindowPanel = action.numberOfWindowPanel;
		    return newState;

			break;
			
		case 'CHANGE_OPENING_FREQUENCY': 
		    var newState = JSON.parse(JSON.stringify(state));
		    newState.door.properties.openingFrequency = action.openingFrequency;
		    return newState;
	
		    break;

		case 'CHANGE_LOCATION_ZONE': 
			var newState = JSON.parse(JSON.stringify(state));
			newState.door.properties.locationZone.country = action.country;
			newState.door.properties.locationZone.region = action.region;
			newState.door.properties.locationZone.climateZoneClass = action.climateZoneClass;
		    return newState;

		    break;

		case 'CHANGE_TO_SELECTED_PRESET': 
			var newState = JSON.parse(JSON.stringify(state));
			newState = action.presetObj;
			return newState;

			break;
			
		case 'CHANGE_TO_DEFAULT_STATE': 
			var newState = JSON.parse(JSON.stringify(state));
			newState = action.defaultObj;
			return newState;

		    break;

		case 'CHANGE_UNIT': 
			var newState = JSON.parse(JSON.stringify(state));
			newState.unit = action.unit;
			return newState;

			break;
		
		case 'CHANGE_LANGUAGE':
			var newState = JSON.parse(JSON.stringify(state));
			newState.language = action.language;
			return newState;

			break;
		
		case 'CHANGE_SAVINGS':
			var newState = JSON.parse(JSON.stringify(state));
			newState.savings = action.savings;
			return newState;

			break;
			
		case 'CHANGE_PRICE':
			var newState = JSON.parse(JSON.stringify(state));
			newState.price = action.price;
			return newState;

			break;

		case 'CHANGE_CURRENCY':
			var newState = JSON.parse(JSON.stringify(state));
			newState.currency = action.currency;
			return newState;

		    break;

		default:
		
		return state
	}
}

// Create a Redux store holding the state of your app.
// Its API is { subscribe, dispatch, getState }.
export let doorSettingsStateStore = createStore(
	stateReducer, // preloadedState,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() // for testing with reduxDevTool chrome extension
);



// WEBPACK FOOTER //
// ./src/assets/scripts/service/redux-service.js